import { getGlobals } from "@models/globals.model";
import { getInstructor, getInstructorsPaths, Instructor } from "@models/instructor.model";
import { Sanity } from "@models/sanity.model";
import { GetStaticPropsContext, NextPage } from "next";
import Layout from "@components/layout";
import { instructorsSlug } from "@utils/routes";
import CatalogSidebar from "@components/catalog-sidebar";
import CatalogDetail from "@components/catalog-detail";

export interface InstructorPageProps extends Sanity.PageProps {
  instructor: Instructor;
}

const InstructorPage: NextPage<InstructorPageProps> = ({ globals, instructor }) => {
  const { hide_header_banner, hero_media, title, social, quote, body, tags, tag_eyebrow, seo } =
    instructor;
  const sidebarHeading = "Explore all instructors";

  return (
    <Layout globals={globals} hideBanner={hide_header_banner} seo={seo}>
      <CatalogSidebar listButtonText={sidebarHeading} backLink={instructorsSlug} />
      <CatalogDetail
        heroMedia={hero_media}
        heading={title}
        social={social}
        quote={quote}
        body={body}
        tagEyebrow={tag_eyebrow}
        tags={tags}
      />
    </Layout>
  );
};

export default InstructorPage;

export async function getStaticProps(context: GetStaticPropsContext) {
  const [globals, instructor] = await Promise.all([
    await getGlobals(),
    await getInstructor(String(context.params?.slug)),
  ]);

  return {
    props: {
      globals,
      instructor,
    },
  };
}

export async function getStaticPaths() {
  const paths = await getInstructorsPaths();
  return { paths, fallback: false };
}
